import { LngLat } from "maplibre-gl";
import { useState } from "react";
import { useIntl } from "react-intl";

import { VisibleLayer } from "@/components/layer-control";
import { MAX_WATER_DEPTH_LAYER_REGEX } from "@/config/map-layer-constants";
import { ScenarioFileDescriptor } from "@/types/descriptor-types";
import { getDisabledLayersScenario } from "@/utils/get-disabled-layers-scenario";

export function useScenarioPreview(descriptor: ScenarioFileDescriptor) {
  const intl = useIntl();
  const { meta } = descriptor;
  const bounds = meta.envelope as [number, number, number, number] | null; // FUTURE - remove as when backend typing is more strict
  const layers = meta.layers || [];

  const disabledLayers = getDisabledLayersScenario({ intl, layers });

  // Max water depth layer is the default visible layer if it exists
  const maxWaterDepthLayerName = layers.find(({ code }) =>
    MAX_WATER_DEPTH_LAYER_REGEX.test(code)
  )?.name;
  const maxWaterDepthLayer = maxWaterDepthLayerName
    ? [{ descriptorId: descriptor.id, layer: maxWaterDepthLayerName }]
    : [];

  const [visibleLayers, setVisibleLayers] = useState<VisibleLayer[]>(maxWaterDepthLayer);
  const [point, setPoint] = useState<LngLat | null>(null);

  const visibleLayersFromLayers = layers.filter(({ name }) =>
    visibleLayers.some(({ layer }) => layer === name)
  );

  return {
    bounds,
    layers,
    disabledLayers,
    visibleLayers,
    setVisibleLayers,
    point,
    setPoint,
    visibleLayersFromLayers,
  };
}
